import * as angular from "angular";
import {AccountModel} from "./angular/models/account.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozObject} from "../persistence-layer/bringoz-object";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.accounts')
  .factory('$account', AccountObjectFactory);

export type $accountFactory = (id: string) => BringozObject<AccountModel>;

/* @ngInject */
function AccountObjectFactory($bringozFactory: $bringozFactory,
                              accountsAPI: BringozApi,
                              Accounts_DS: DataStoreConfig,
                              Accounts_PN: PushNotificationsConfig) {
  function $account(id: string) {
    return $bringozFactory<AccountModel>(id, accountsAPI, Accounts_DS, Accounts_PN);
  }

  return $account;
}
